var map = {
	"./klarna-au.png": 71435,
	"./klarna-ca.png": 1061,
	"./klarna-jewlr-payments-2x.png": 10502,
	"./klarna-jewlr-payments.png": 82461,
	"./klarna-uk.png": 87289,
	"./klarna-us.png": 23153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6038;